const {
  requiredWidgetSettingProperties,
  allowedWidgetOptions,
} = require('./../config/const.config')

const validateProductResponse = (data) => {
  const requiredProperties = ['sortedProducts', 'type', 'widgetSettings']
  for (let i = 0; i < requiredProperties.length; i++) {
    const property = requiredProperties[i]
    const hasProperty = Object.prototype.hasOwnProperty.call(data, property)
    if (!hasProperty) {
      throw `Missing required property ${property}`
    }
  }

  for (let i = 0; i < requiredWidgetSettingProperties.length; i++) {
    const property = requiredWidgetSettingProperties[i]
    const hasProperty = Object.prototype.hasOwnProperty.call(
      data.widgetSettings,
      property
    )
    if (!hasProperty) {
      throw `Missing required property ${property}`
    }
  }

  if (!allowedWidgetOptions.includes(data.type)) {
    throw `Invalid widget type, must be one of ${allowedWidgetOptions.join(
      ','
    )}`
  }
}

module.exports = { validateProductResponse }
